import {
	defineCartFlyoutComponent,
	defineCartFooterTableComponent,
	defineCartLineItemComponent,
	defineCheckoutButtonComponent,
	defineSidebarComponent,
} from "@nx-paeonia/feature-components";

defineSidebarComponent();
defineCartFlyoutComponent();
defineCartFooterTableComponent();
defineCartLineItemComponent();
defineCheckoutButtonComponent();
